import React, { type FC } from 'react';
import { useFormikContext } from 'formik';

import { LoadingStatus } from 'app/constants/SideEffectStatus';
import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { Icon, IconSize } from 'app/design-system/components/Icon';
import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';

import dictionary from './Footer.dictionary.json';

import styles from './Footer.module.scss';

type ModalFooterProps = {
  handleClose: VoidFunction;
};

export const ModalFooter: FC<ModalFooterProps> = ({ handleClose }) => {
  const { isSubmitting, status } = useFormikContext();
  const { t } = useTranslation();
  const successStatus = status === LoadingStatus.SUCCESS;

  const buttonProps = {
    type: ButtonType.SUBMIT,
    ['data-test']: 'submit-btn',
    loading: isSubmitting,
    className: styles.save,
  };

  return (
    <Modal.Footer>
      <Button type={ButtonType.RESET}
              onClick={handleClose}>
        {t(dictionary.cancel)}
      </Button>

      {successStatus
        ? (
          <Button {...buttonProps}
                  intent={ButtonIntent.SUCCESS}>
            <Icon icon="check"
                  size={IconSize.SMALL}
                  className={styles.iconSuccess} />
          </Button>
        )
        : (
          <Button {...buttonProps}
                  intent={ButtonIntent.PRIMARY}>
            {t(dictionary.save)}
          </Button>
        )}
    </Modal.Footer>
  );
};

